
import { Button } from '@/components/ui/button';
import HeroImage from './HeroImage';

interface HeroSectionProps {
  onOpenContact: () => void;
}

const HeroSection = ({ onOpenContact }: HeroSectionProps) => {
  return (
    <div className="relative overflow-hidden py-16 lg:py-24">
      {/* Background Image with enhanced overlay */}
      <div className="absolute inset-0">
        <HeroImage />
        <div className="absolute inset-0 bg-gradient-to-br from-background/95 via-background/90 to-background/85"></div>

        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-1/3 left-1/3 w-1/4 h-1/4 bg-gradient-radial from-primary/15 to-transparent rounded-full blur-2xl"></div>
          <div className="absolute bottom-1/3 right-1/3 w-1/5 h-1/5 bg-gradient-radial from-primary-glow/10 to-transparent rounded-full blur-xl"></div>
        </div>
      </div>
      <div className="relative container mx-auto px-4">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 leading-tight">
            Embed Aging-at-Home Strategy{" "}
            <span className="text-primary">
              Into Your Practice
            </span>
          </h1>
          <h2 className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed mb-10">
            SeniorThrive helps you protect client independence, strengthen multi-generational relationships, and stay indispensable as families navigate aging.
          </h2>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              className="px-8 py-6 text-lg shadow-floating hover:shadow-glow transition-all duration-300 hover:-translate-y-1"
              onClick={onOpenContact}
            >
              Start Your Advisor Partnership
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="px-8 py-6 text-lg border-2 hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300 hover:-translate-y-1"
              onClick={onOpenContact}
            >
              Schedule a Strategy Call
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
